import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import * as actions from './actions'
import * as getters from './getters'
import userProfile from './modules/userProfile'
import loading from './modules/loading'
import filterSerialList from './modules/filterSerialList'
import filterDateRange from './modules/filterDateRange'
import filterReportLicenseExpiry from './modules/filterReportLicenseExpiry'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'prod'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    userProfile,
    loading,
    filterSerialList,
    filterDateRange,
    filterReportLicenseExpiry
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js